//Variable global que se encarga de la activacion del botón, por como está montado ahora mismo
//el valor de este viene desde entornoMapfreSP.js (index.js) y se setea en validacion()
let ActivadorBTN;

function handleClickBtnDeshabilitado() {
    for (let index = 0; index < ActivadorBTN.length; index++) {
        if (ActivadorBTN[index].value != true) {

            const inpuntElement = document.getElementsByName(`${ActivadorBTN[index].nombre}`);
            const errorTexts = document.getElementsByClassName(`error__${ActivadorBTN[index].nombre.toLowerCase()}`);

            for (let indexErrText = 0; indexErrText < errorTexts.length; indexErrText++) {

                errorTexts[indexErrText].style.display = "block";

                errorTexts[indexErrText].innerHTML === "" ?
                    ActivadorBTN[index].nombre != "Compañía_actual" ?
                        errorTexts[indexErrText].innerHTML = "El campo es obligatorio" :
                        errorTexts[indexErrText].innerHTML = "Selecciona una opción" :
                    errorTexts[indexErrText].innerHTML = errorTexts[indexErrText].innerHTML;

                inpuntElement[indexErrText].classList.add("form-control-error");

            }
        }
    }
}

export function clickBotonDeshabilitado(objBtnValidate) {
    ActivadorBTN = objBtnValidate;

    const observer = new MutationObserver(() => {
        const btnInactivo = document.getElementsByClassName("btn_in_activo");

        if (btnInactivo.length > 0) {

            for (let index = 0; index < btnInactivo.length; index++) {
                btnInactivo[index].addEventListener("click", handleClickBtnDeshabilitado);
                btnInactivo[index].addEventListener("touchstart", handleClickBtnDeshabilitado);
            }

            // Detener la observación después de encontrar el elemento
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

}


// WEBPACK FOOTER //
// ./js/utils/modal/handleBtnDeshabilitado.js